import { Store } from "vuex";
export default class ScenarioSocketHandler {
  /**
   * SCENARIO_ROOMS_EDITED
   * */
  static async scenarioRoomsEdited(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    await store.dispatch("GraphicClientStore/updateSpace", data);
    await store.dispatch("SpaceStore/setSpaceAction", data);
  }
  /**
   * SCENARIO_IMAGES_UPDATED
   * */
  static async scenarioImagesUpdated(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    await store.dispatch("GraphicClientStore/updateSpace", data);
  }
}
